// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { ExternalNetworkScanTypeSchema } from '../inputTypeSchemas/ExternalNetworkScanTypeSchema'
import { ExternalNetworkScanStatusSchema } from '../inputTypeSchemas/ExternalNetworkScanStatusSchema'

/////////////////////////////////////////
// EXTERNAL NETWORK SCAN SCHEMA
/////////////////////////////////////////

export const ExternalNetworkScanSchema = z.object({
  scanType: ExternalNetworkScanTypeSchema,
  status: ExternalNetworkScanStatusSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  surfaceId: z.string(),
  currentStage: z.string().nullable(),
  entitiesUpserted: z.number().int(),
  newEntities: z.number().int(),
  removedEntities: z.number().int(),
  startedAt: z.coerce.date().nullable(),
  completedAt: z.coerce.date().nullable(),
  failureReason: z.string().nullable(),
  chainDiscovery: z.boolean(),
  chainRemaining: JsonValueSchema.nullable(),
  pendingTransitions: JsonValueSchema.nullable(),
  createdAt: z.coerce.date(),
  activityLog: JsonValueSchema.array(),
})

export type ExternalNetworkScan = z.infer<typeof ExternalNetworkScanSchema>

export default ExternalNetworkScanSchema;
